import { IAsyncActionCreator, createAsyncActionCreator } from '../store/actions/createActionCreator';
import { IItemCacheThunkAction, IItemCacheDispatch } from '../store/actions/ItemCacheActions';
import { resolveItems } from '../operations/getItems';
import { preferredLayoutFacet } from '../facets/ScopeFacets';

export interface ISetPreferredLayoutPayload {
  itemsScopeItemKey: string;
  layoutHandlerKey: string;
}

export const setPreferredLayout: IAsyncActionCreator<ISetPreferredLayoutPayload, IItemCacheThunkAction<void>> =
  createAsyncActionCreator((payload: ISetPreferredLayoutPayload) => {
    const {
      itemsScopeItemKey,
      layoutHandlerKey
    } = payload;

    return (dispatch: IItemCacheDispatch) => {
      dispatch(resolveItems({
        items: {
          [itemsScopeItemKey]: {
            ...preferredLayoutFacet.pack({
              layoutHandlerKey
            })
          }
        }
      }));
    };
  });
